<template>
  <div :class="b(modifiers)">
    <a
      :class="b('inner', modifiers)"
      :href="linkHref"
      :target="linkTarget"
    >
      <e-icon-sprite :icon="`i-${icon}`" />
      <!-- NOTE: v-html necessary for manual linebreaks -->
      <!-- eslint-disable vue/no-v-html -->
      <div
        v-html="title"
        :class="b('title', modifiers)"
      ></div>
      <!-- eslint-enable vue/no-v-html -->
      <div :class="b('filler')"></div>
      <div :class="b('more', modifiers)">
        <e-button
          v-if="linkText"
          :variant="inverted ? 'secondary' : 'primary'"
          width="auto"
          spacing="200"
        >
          {{ linkText }}
        </e-button>
        <template v-else>{{ $t('c-ids-menu-tile.showMore') }}</template>
      </div>
    </a>
  </div>
</template>

<script>
  import eButton from '@/elements/e-button.vue';
  import eIconSprite from '@/elements/e-icon-sprite.vue';

  /**
   * Renders the a large link tile for IDS.
   */
  export default {
    name: 'c-ids-menu-tile',
    components: {
      eButton,
      eIconSprite,
    },

    // components: { },
    // mixins: [],

    props: {
      /**
       * Title text of the tile.
       */
      title: {
        type: String,
        default: '',
      },

      /**
       * (optional) Link text. If used the "show more" text is replaced with a Button.
       */
      linkText: {
        type: String,
        default: '',
      },

      /**
       * Destination href of the link.
       */
      linkHref: {
        type: String,
        default: '',
      },

      /**
       * (optional) Destination target of the link.
       */
      linkTarget: {
        type: String,
        default: '',
      },

      /**
       * (optional) Name of the sprite icon to be shown.
       */
      icon: {
        type: String,
        default: 'star',
      },

      /**
       * (optional) Invert colors.
       */
      inverted: {
        type: Boolean,
        default: false,
      },

      /**
       * (optional) Sets content alignment.
       */
      alignment: {
        type: String,
        default: 'center',
        validator(value) {
          return ['center', 'left'].includes(value);
        },
      },
    },
    // data() {
    //   return {};
    // },

    computed: {
      /**
       * Defines state modifier classes.
       *
       * @returns {Object}
       */
      modifiers() {
        const { inverted, alignment } = this;

        return { inverted, alignment };
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  };
</script>

<style lang="scss">
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/functions';
  @use '@/setup/scss/extends' as *;

  .c-ids-menu-tile-container {
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto;
    column-gap: functions.rem(variables.$spacing--50);
    row-gap: functions.rem(variables.$spacing--50);

    @include mixins.media(md) {
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
    }

    .c-ids-menu-tile {
      width: 100%;
    }
  }

  .c-ids-menu-tile {
    display: inline-block;
    background: variables.$color-grayscale--1000;
    color: variables.$color-primary--1;
    user-select: none;

    &--inverted {
      background: variables.$color-primary--1;
      color: variables.$color-grayscale--1000;
    }

    &__inner {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      height: 100%;
      padding: functions.rem(variables.$spacing--80 variables.$spacing--50);
      color: inherit;

      &:hover {
        color: inherit;
      }

      &--alignment-center {
        padding: functions.rem(variables.$spacing--150 variables.$spacing--80);

        > .e-icon-sprite {
          width: functions.rem(80px);
          height: functions.rem(80px);
          margin: 0 auto;
        }
      }

      &--alignment-left {
        > .e-icon-sprite {
          width: functions.rem(80px);
          height: functions.rem(80px);
        }
      }
    }

    &__filler {
      flex: 1;
    }

    &__title,
    &__more {
      &--alignment-center {
        text-align: center;
      }
    }

    &__title {
      @extend %hyphens;
      @include mixins.font-size(variables.$font-size--24);

      margin-top: functions.rem(variables.$spacing--30);

      &--alignment-center {
        @include mixins.font-size(variables.$font-size--32);

        margin-top: functions.rem(variables.$spacing--40);
      }
    }

    &__more {
      @include mixins.font-size(variables.$font-size--16);

      margin-top: functions.rem(variables.$spacing--10);
      color: variables.$color-primary--2;

      &--alignment-left {
        margin-top: functions.rem(variables.$spacing--30);
      }
    }
  }
</style>
